namespace ekh {
    angular
    .module('ekh')
    .directive('imageResize', (imageService): ng.IDirective => {
        return {
            restrict: 'A',
            link: ($scope:any, $element:JQuery, $attrs:any) => {
                const [size] = imageService.getAppropriateSize($(window).width());
                let source = $attrs['imageResize'];

                if(!source){
                    let imageObserver = $attrs.$observe('imageResize', value => {
                        if(value){
                            source = value;
                            applySource();
                            imageObserver();
                        }
                    });
                } else {
                    applySource();
                }

                function applySource(){
                    if( source ) {
                        source = source.replace(/(width|height)=\d+&?/g, '');
                        const hasParams = /\?/.test(source);
                        source += `${hasParams ? '&' : '?'}width=${size}`;

                        if($element[0].tagName.toUpperCase() === 'IMG'){
                            $element.attr('src', source);
                        } else {
                            $element.css({ 'background-image': `url('${source}')`});
                        }
                    }
                }
            }
        };
    });
}
